import React, { useState, useEffect } from 'react';
import Leftbar from './../components/Leftbar';
import Topbar from './../components/Topbar';
import { Link } from 'react-router-dom';
import TopNav from '../components/TopNav';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { connect, useSelector } from 'react-redux';
import { toggleLoader } from '../actions/loader';
import config from "../config/config";
import axios from "axios";
import { getOfferListing, displayError, displaySuccess, getCrossSellListing, activeCrossSell } from '../Utils/utils';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Translate, I18n } from "react-redux-i18n";
import Alert from 'react-bootstrap/Alert'

const CrossSell = (props) => {
  const [list, setList] = useState([]);
  const [tempVarId, setTempVarId] = useState('');
  const [is_delete, setIsDelete] = useState(false);
  const [is_active, setIsActive] = useState(0);

  useEffect(async () => {
    props.toggleLoader(true);
    var getCross_var = await getCrossSellListing();
    console.log(getCross_var);
    setList(getCross_var);
    props.toggleLoader(false);
  }, [])
  const deleteCrossSell = async () => {
    var token = localStorage.getItem('token');
    props.toggleLoader(true);
    let path = config.siteUrl;
    axios.get(path + "/cross_sell/delete/" + tempVarId, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    })
      .then(async (response) => {
        displaySuccess('Deleted Successfully');
        var getCross_var = await getCrossSellListing();
        setList(getCross_var);
        props.toggleLoader(false);
      })
      .catch(function (error) {
        props.toggleLoader(false);
        if (error.response.status === 401) {
          window.location.href = '/';
        }
        displayError(error);
      });
  }
  const activateCrossSell = async (id, is_active) => {
    props.toggleLoader(true);
    if (is_active === 1) {
      var active_var = await activeCrossSell(id, 0);
    }
    else {
      var active_var = await activeCrossSell(id, 1);
    }
    console.log(active_var);
    setIsActive(active_var);
    var getCross_var = await getCrossSellListing();
    setList(getCross_var);
    props.toggleLoader(false);
  }
  return (
    <>
      <body id="page-top">
        <TopNav />
        <div id="wrapper">

          <Leftbar />

          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Topbar />
              <div className="container-fluid">
                <div className="row justify-content-between mb-4">
                  <div className="col">
                    <h1 className="h3 mb-0 title-top">{I18n.t('Cross Sell')}</h1>
                  </div>
                  <div className="col-auto ml-auto d-none d-sm-inline-block d-block d-sm-none">
                    <div className="form-row">
                      <div className="col">
                        <Link to="/new-cross-sell">
                          <a className=" btn btn-light">
                            <i className="fas fa-plus fa-sm" /> {I18n.t('New Cross Sell')}</a></Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <Table className="table align-items-center mb-0">
                            <Thead>
                              <Tr>
                                {/* <Th>Offer</Th> */}
                                <Th>{I18n.t('Title')}</Th>
                                <Th>{I18n.t('Value Offer')}</Th>
                                <Th>{I18n.t('% Discount')}</Th>
                                <Th>{I18n.t('Quantity')}</Th>
                                <Th>{I18n.t('End Date / Time')}</Th>
                                <Th>{I18n.t('Status')}</Th>
                                <Th>{I18n.t('Action')}</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {(list.length === 0) ? <Tr>
                                <Td colspan="7" style={{ textAlign: 'center' }}>
                                  <Alert key={'alert'} variant={'info'}>
                                    {I18n.t('No CrossSell')}
                                  </Alert>
                                </Td>
                              </Tr> : ''}
                              {list.map((info) => (
                                <Tr>
                                  {/* <Td>{info.}</Td> */}
                                  <Td>{info.title}</Td>
                                  <Td>{info.price}</Td>
                                  <Td>{info.discount_percentage}%</Td>
                                  <Td>{info.quantity_of_customer}</Td>
                                  <Td>{info.end_date_new}</Td>
                                  <Td>
                                    {(info.is_active === 1) ? <span className='text-success'> {I18n.t('Active')} </span> : <span className='text-danger'> {I18n.t('Inactive')} </span>}
                                  </Td>
                                  <Td>
                                    <div className>
                                      <Link to={"/cross-sell-edit/" + info.id}title={I18n.t("Edit")}>
                                        <a className="items-center m-1 btn-outline-dark btn btn-sm">
                                          <i className="far fa-edit"></i>
                                        </a>
                                      </Link>
                                      <a className="flex items-center m-1 btn-outline-danger btn btn-sm"
                                        onClick={e => {
                                          setTempVarId(info.id)
                                          setIsDelete(true)
                                        }}title={I18n.t("Delete")}
                                      >
                                        <i className="far fa-trash-alt"></i>
                                        {/* {I18n.t('Delete')} */}
                                      </a>
                                      {/* <a className="flex items-center m-1 btn-outline-warning btn btn-sm" href="">
                                        <i className="fa fa-share-alt"></i>
                                       {I18n.t('Share')}
                                      </a> */}

                                      <a className="flex items-center m-1 btn-outline-primary btn btn-sm" href
                                        onClick={e => { activateCrossSell(info.id, info.is_active) }}
                                      >
                                        {(info.is_active === 0) ? <i className="fas fa-play"title={I18n.t("Inactive")} /> : <i className="fa fa-pause" title={I18n.t("Active")}/>}
                                      </a>
                                    </div>
                                  </Td>
                                </Tr>
                              ))}


                            </Tbody>
                          </Table>
                        </div>
                      </div>
                      {is_delete === true ? (
                        <SweetAlert
                          warning
                          showCancel
                          confirmBtnText="Yes"
                          confirmBtnBsStyle="danger"
                          title={I18n.t('Are you sure?')}
                          onConfirm={(e) => {
                            deleteCrossSell()
                            setIsDelete(false)
                            // window.location.reload(false)
                          }}
                          onCancel={(e) => {
                            setIsDelete(false)
                            setTempVarId('')
                          }}
                          focusCancelBtn
                        >
                          {I18n.t('Do you want to delete this CrossSell?')}
                        </SweetAlert>
                      ) : ([]
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body >
    </>
  )
}
const mapDispatchToProps = {
  toggleLoader
}
const mapStateToProps = (state) => {
  return {
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CrossSell);